export default "__VITE_ASSET__d2a40d6b__"